const general_ledgers = {
  permissionSource: 'api::general-ledger.general-ledger',
  creationTitle: 'Create General Ledger',
  creationEndPoint: '/general-ledgers',
  detailTitle: 'General Ledger: :code',
  detailEndPoint: '/general-ledgers/:id?populate=*',
  detail: [
    {
      label: 'Code',
      value: 'code',
      tag: 'input',
      type: 'text',
      placeholder: 'General Ledger Code',
      required: true,
    },
    {
      label: 'Title',
      value: 'title',
      tag: 'input',
      type: 'text',
      placeholder: 'General Ledger Title',
      required: true,
    },
    {
      label: 'Description',
      value: 'description',
      tag: 'richTextarea',
      placeholder: 'General Ledger Description',
    },
    {
      isLayout: true,
      layoutPattern: '1-1-1',
      children: [
        {
          label: 'Create Date / Time',
          value: 'custom_created_at',
          tag: 'static-text',
        },
        {
          label: 'Publish Date / Time',
          value: 'publishedAt',
          tag: 'static-text',
        },
        {
          label: 'Update Date / Time',
          value: 'custom_updated_at',
          tag: 'static-text',
        },
      ],
    },
  ],
}
export default general_ledgers
